import { Logger } from "@lululemon/mwa-logger";

const logger = new Logger({
  owner: "outfitting",
  app: "outfitting-app",
});

export default logger;
